// extracted by mini-css-extract-plugin
export default {"hero":"Philosophie_hero__SiX3R","section":"Philosophie_section__TRlfY","text":"Philosophie_text__2jKlB","list":"Philosophie_list__AO6-P"};